// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/compliance.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AcknowledgeAlertRequest, AcknowledgeAlertResponse, BulkImportGostStandardsRequest, BulkImportGostStandardsResponse, BulkImportOkpd2Request, BulkImportOkpd2Response, BulkImportTnVedRequest, BulkImportTnVedResponse, CertificationType, CreateCertificationTypeRequest, CreateProductCertificationRequest, DeleteCertificationTypeRequest, DeleteProductCertificationRequest, GetCategoryOkpd2MappingRequest, GetCategoryOkpd2MappingResponse, GetExpiringCertificationsRequest, GetExpiringCertificationsResponse, GetGostStandardRequest, GetGostSupersessionChainRequest, GetGostSupersessionChainResponse, GetOkpd2HierarchyRequest, GetOkpd2HierarchyResponse, GetProductComplianceRequest, GetProductComplianceResponse, GetTnVedHierarchyRequest, GetTnVedHierarchyResponse, GostStandard, InitDefaultCertificationTypesRequest, InitDefaultCertificationTypesResponse, ListCertificationAlertsRequest, ListCertificationAlertsResponse, ListCertificationTypesRequest, ListCertificationTypesResponse, ListProductCertificationsRequest, ListProductCertificationsResponse, ProductCertification, SearchGostStandardsRequest, SearchGostStandardsResponse, SearchOkpd2Request, SearchOkpd2Response, SearchTnVedRequest, SearchTnVedResponse, SetCategoryOkpd2MappingRequest, SetCategoryOkpd2MappingResponse, SetProductGostRequest, SetProductGostResponse, SetProductOkpd2Request, SetProductOkpd2Response, SetProductTnVedRequest, SetProductTnVedResponse, SuggestGostRequest, SuggestGostResponse, SuggestOkpd2Request, SuggestOkpd2Response, SuggestTnVedRequest, SuggestTnVedResponse, UpdateCertificationTypeRequest, UpdateProductCertificationRequest } from "./compliance_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.ComplianceService
 */
export const ComplianceService = {
  typeName: "omnios.v1.ComplianceService",
  methods: {
    /**
     * Reference data (read-only for most users)
     *
     * @generated from rpc omnios.v1.ComplianceService.SearchGostStandards
     */
    searchGostStandards: {
      name: "SearchGostStandards",
      I: SearchGostStandardsRequest,
      O: SearchGostStandardsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.GetGostStandard
     */
    getGostStandard: {
      name: "GetGostStandard",
      I: GetGostStandardRequest,
      O: GostStandard,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.GetGostSupersessionChain
     */
    getGostSupersessionChain: {
      name: "GetGostSupersessionChain",
      I: GetGostSupersessionChainRequest,
      O: GetGostSupersessionChainResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.SearchOkpd2
     */
    searchOkpd2: {
      name: "SearchOkpd2",
      I: SearchOkpd2Request,
      O: SearchOkpd2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.GetOkpd2Hierarchy
     */
    getOkpd2Hierarchy: {
      name: "GetOkpd2Hierarchy",
      I: GetOkpd2HierarchyRequest,
      O: GetOkpd2HierarchyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.SearchTnVed
     */
    searchTnVed: {
      name: "SearchTnVed",
      I: SearchTnVedRequest,
      O: SearchTnVedResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.GetTnVedHierarchy
     */
    getTnVedHierarchy: {
      name: "GetTnVedHierarchy",
      I: GetTnVedHierarchyRequest,
      O: GetTnVedHierarchyResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Certification types
     *
     * @generated from rpc omnios.v1.ComplianceService.ListCertificationTypes
     */
    listCertificationTypes: {
      name: "ListCertificationTypes",
      I: ListCertificationTypesRequest,
      O: ListCertificationTypesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.CreateCertificationType
     */
    createCertificationType: {
      name: "CreateCertificationType",
      I: CreateCertificationTypeRequest,
      O: CertificationType,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.UpdateCertificationType
     */
    updateCertificationType: {
      name: "UpdateCertificationType",
      I: UpdateCertificationTypeRequest,
      O: CertificationType,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.DeleteCertificationType
     */
    deleteCertificationType: {
      name: "DeleteCertificationType",
      I: DeleteCertificationTypeRequest,
      O: CertificationType,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.InitDefaultCertificationTypes
     */
    initDefaultCertificationTypes: {
      name: "InitDefaultCertificationTypes",
      I: InitDefaultCertificationTypesRequest,
      O: InitDefaultCertificationTypesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Product certifications
     *
     * @generated from rpc omnios.v1.ComplianceService.CreateProductCertification
     */
    createProductCertification: {
      name: "CreateProductCertification",
      I: CreateProductCertificationRequest,
      O: ProductCertification,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.UpdateProductCertification
     */
    updateProductCertification: {
      name: "UpdateProductCertification",
      I: UpdateProductCertificationRequest,
      O: ProductCertification,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.DeleteProductCertification
     */
    deleteProductCertification: {
      name: "DeleteProductCertification",
      I: DeleteProductCertificationRequest,
      O: ProductCertification,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.ListProductCertifications
     */
    listProductCertifications: {
      name: "ListProductCertifications",
      I: ListProductCertificationsRequest,
      O: ListProductCertificationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Product regulatory links
     *
     * @generated from rpc omnios.v1.ComplianceService.SetProductOkpd2
     */
    setProductOkpd2: {
      name: "SetProductOkpd2",
      I: SetProductOkpd2Request,
      O: SetProductOkpd2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.SetProductTnVed
     */
    setProductTnVed: {
      name: "SetProductTnVed",
      I: SetProductTnVedRequest,
      O: SetProductTnVedResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.SetProductGost
     */
    setProductGost: {
      name: "SetProductGost",
      I: SetProductGostRequest,
      O: SetProductGostResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.GetProductCompliance
     */
    getProductCompliance: {
      name: "GetProductCompliance",
      I: GetProductComplianceRequest,
      O: GetProductComplianceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Alerts
     *
     * @generated from rpc omnios.v1.ComplianceService.ListCertificationAlerts
     */
    listCertificationAlerts: {
      name: "ListCertificationAlerts",
      I: ListCertificationAlertsRequest,
      O: ListCertificationAlertsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.AcknowledgeAlert
     */
    acknowledgeAlert: {
      name: "AcknowledgeAlert",
      I: AcknowledgeAlertRequest,
      O: AcknowledgeAlertResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.GetExpiringCertifications
     */
    getExpiringCertifications: {
      name: "GetExpiringCertifications",
      I: GetExpiringCertificationsRequest,
      O: GetExpiringCertificationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * AI suggestions
     *
     * @generated from rpc omnios.v1.ComplianceService.SuggestOkpd2
     */
    suggestOkpd2: {
      name: "SuggestOkpd2",
      I: SuggestOkpd2Request,
      O: SuggestOkpd2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.SuggestTnVed
     */
    suggestTnVed: {
      name: "SuggestTnVed",
      I: SuggestTnVedRequest,
      O: SuggestTnVedResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.SuggestGost
     */
    suggestGost: {
      name: "SuggestGost",
      I: SuggestGostRequest,
      O: SuggestGostResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Admin bulk import
     *
     * @generated from rpc omnios.v1.ComplianceService.BulkImportGostStandards
     */
    bulkImportGostStandards: {
      name: "BulkImportGostStandards",
      I: BulkImportGostStandardsRequest,
      O: BulkImportGostStandardsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.BulkImportOkpd2
     */
    bulkImportOkpd2: {
      name: "BulkImportOkpd2",
      I: BulkImportOkpd2Request,
      O: BulkImportOkpd2Response,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.BulkImportTnVed
     */
    bulkImportTnVed: {
      name: "BulkImportTnVed",
      I: BulkImportTnVedRequest,
      O: BulkImportTnVedResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Category mapping
     *
     * @generated from rpc omnios.v1.ComplianceService.SetCategoryOkpd2Mapping
     */
    setCategoryOkpd2Mapping: {
      name: "SetCategoryOkpd2Mapping",
      I: SetCategoryOkpd2MappingRequest,
      O: SetCategoryOkpd2MappingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.ComplianceService.GetCategoryOkpd2Mapping
     */
    getCategoryOkpd2Mapping: {
      name: "GetCategoryOkpd2Mapping",
      I: GetCategoryOkpd2MappingRequest,
      O: GetCategoryOkpd2MappingResponse,
      kind: MethodKind.Unary,
    },
  }
};

